import React, {useEffect, useState} from "react";
import { fetchBlogHomeCategories } from "../../api/GlobalApi";
import { Link } from "react-router-dom";

function BlogCategories() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBlogHomeCategories()
        .then((data) => {
            setCategories(data);
            setLoading(false);
        })
        .catch(() => setLoading(false));
    }, []);

    if (loading)
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.spinner}></div>
      </div>
    );

    if (!categories) {
    return (
      <div style={styles.errorContainer}>
        <h2>Categories Not Found</h2>
        <p>There is no categories.</p>
      </div>
    );
  }

    return(
        <main className="main-content">
            
            <section className="section">
                <div className="section-header">
                    <h2 className="section-title">Blog categories</h2>
                </div>
                <div className="categories-grid">
                    {Array.isArray(categories) && categories.length > 0 ? (
                        categories.map((cat) => (
                           <Link to={`/blogs/category/${cat.slug}`} key={cat.id} className="category-card" style={{textDecoration: "none"}}>
                                <div className="category-icon" style={{
                                    background: cat.color,
                                    backgroundImage: `url(${cat.image_url})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    boxShadow: `0 0 0 2px ${cat.color}`
                                    }}>

                                </div>
                                <div className="category-name">{cat.name}</div>
                            </Link>
                            ))
                    ) : (
                        <p>No categories found.</p>
                    )}
                </div>
            </section>
            
        </main>
    );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    padding: "20px",
    textAlign: "center",
  },
  noPosts: {
    textAlign: "center",
    padding: "40px 20px",
    fontSize: "18px",
    color: "#666",
  },
};

// Inject global CSS once (safe for dev/hmr)
const GLOBAL_STYLE_ID = "devpage-global-styles";
if (typeof document !== "undefined" && !document.getElementById(GLOBAL_STYLE_ID)) {
  const css = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .stars span {
      color: #FFD700;
      font-size: 1rem;
      margin-right: 1px;
      line-height: 1;
    }
    .game-rating { display: flex; align-items: center; gap: 8px; }
    .rating-text { font-size: 0.9rem; color: #333; }
  `;
  const styleEl = document.createElement("style");
  styleEl.id = GLOBAL_STYLE_ID;
  styleEl.innerHTML = css;
  document.head.appendChild(styleEl);
}

export default BlogCategories;